export const calcNextPage = ({
  lastPageItemsLength,
  limit,
  initPage,
  allCurrentPagesLength,
}) => {
  return lastPageItemsLength < limit ? null : initPage + allCurrentPagesLength;
};
